import React from 'react';
import { Button, Modal } from '@bedrock/components';
import CopyIcon from '@mpc/common/src/components/CopyIcon';
import { disabledDate } from '@mpc/common/src/utils/date';
import { $sType } from '@mpc/common';
import moment from 'moment';
import { enums } from "services/api";
import createFormItemRow from '@mpc/common/src/components/SForm/createFormItemRow';
import InvoiceInformation from '@mpc/common/src/features/InvoiceInformation';

const basicOption = [
  {
    name: '是',
    value: true
  },
  {
    name: '否',
    value: false
  },
]

const ModalConfirm = ({ value, oldValue, title, content, formData }) => {
  return new Promise((resolve, reject) => {
      if (oldValue === undefined) {
          resolve(value)
          return
      }
      if (formData?.invoice_info?.invoice_list.length) {
          Modal.confirm({
              title,
              content,
              onOk: () => {
                  resolve(value)
              },
              onCancel: () => {
                  reject(oldValue)
              }
          })
      } else {
          resolve(value)
      }
  })
}


const PrePaymentFormModel = createFormItemRow({
  'base_info.prepayment_no': {
    label: '预付单号',
    col: 12,
    view: true,
    componentClass: 'input',
    show: true,
    elementProps: ({ detailData }: { detailData: any }) => {
      return {
        showComponent:() => {
          const text = detailData?.base_info?.prepayment_no
          return text ? (
            <div className='flex items-center'>
              <span>{text}</span>
              <CopyIcon text={text} tipToolTitle={'复制'} />
            </div>
          ) : (
            <span className='text-color-3'>自动生成</span>
          );
        },
      };
    },
  },
  'base_info.demand_id': {
    label: '来源单号',
    col: 12,
    view: true,
    componentClass: 'input',
    elementProps: ({ detailData }: { detailData: any }) => {
      return {
        showComponent:() => {
          const text = detailData?.base_info?.demand_id
          return text ? (
            <div className='flex items-center'>
              <Button type='link' onClick={() => {
                $sType === 'inner' ?
                  window.open(`/#/channelDistributionWorkbench/channelDistributionGroup/projectDetailSingle/${text}`)
                :
                  window.open(`/#/outWorkbenchPortal/outNormalPurchase/makingPortal?projectId=${text}`)
              }}>{text}</Button>
              <CopyIcon text={text} tipToolTitle={'复制'} />
            </div>
          ) : (
            '--'
          );
        },
      };
    },
  },
  'base_info.$prepayment_amount': {
    label: '预付金额',
    col: 12,
    required: true,
    componentClass: 'currencyType',
    view: true,
    elementProps: {
      selectDisabled: true,
    },
    formItemKeyMap: {
      value: 'base_info.prepayment_amount',
      currency: 'base_info.currency',
    },
  },
  'base_info.prepayment_deadline': {  
    label: '预付截止日期',
    col: 12,
    required: true,
    componentClass: 'datePicker',
    view: true,
    elementProps: {
      disabledDate: (value: any) => disabledDate(value, moment().add(1, 'day')),
    },
  },
  'base_info.apply_summary': {
    label: '申请简介',
    col: 24,
    view: true,
    required: true,
    componentClass: 'input',
    elementProps: {
      maxLength: 20,
      showCount: true,
    },
  },
  'base_info.apply_content': {
    label: '申请内容',
    col: 24,
    componentClass: 'textarea',
    view: true,
    required: true,
    elementProps: {
      maxLength: 200,
    },
  },
  'base_info.attachments': {
    label: '附件',
    col: 24,
    required: false,
    componentClass: 'upload',
    elementProps: {
      tip: '单个文件不能超过200M',
      fileSizeLimit: 200 * 1024 * 1024,
    }
  },
  'base_info.invoice_entity': {
    label: '开票主体',
    col: 12,
    view: true,
    componentClass: 'input',
  },
  // 合同信息
  'contract_info.contract_no': {
    label: '合同',
    col: 12,
    view: true,
    componentClass: 'input',
    required: true,
    elementProps: ({ detailData }: { detailData: any }) => {
      return {    
        showComponent:() => {
          return (
            <div className='border-solid border border-color-2 rounded-md py-2 px-3'>
              <div className='text-base fw-bold one-rows-ellipsis'>{detailData?.contract_info?.contract_name}</div>
              <div style={{color: 'var(--text-color-3)'}} className='flex items-center text-xs'>
                合同编号： {detailData?.contract_info?.contract_no || '--'}
                <CopyIcon text={detailData?.contract_info?.contract_no} tipToolTitle={'复制'} />
              </div>
            </div>
          )
        },
      }
    },
  },
  'invoice_info.invoice_method': {
    label: '发票方式',
    col: 12,
    view: true,
    required: true,
    componentClass: 'select',
    elementProps: ({ formData }) => {
      return {
        options: [
          { name: '有票预付', value: 1 },
          { name: '无票预付', value: 2 },
        ],
        showSearch: false,
      }
    },
  },
  'invoice_info.invoice_belong_area': {
    label: '发票国家/地区',
    required: true,
    componentClass: 'select',
    col: 12,
    elementProps: ({ formData }) => {
      return {
        options: enums.InvoiceBelongAreaEnum.values(),
        changeInterceptor: (value, oldValue) => {
          return ModalConfirm({
            value, oldValue, formData,
            title: '确定更改发票国家/地区吗？',
            content: '更改后，发票信息会清空，需重新上传',
          })
        }
      }
    }
  },
  'invoice_info.is_oversea_invoice': {
    label: '是否海外INVOICE',
    required: true,
    componentClass: 'radio',
    col: 12,
    elementProps: ({ formData }) => {
      return {
        options: basicOption,
        disabled: formData?.invoice_info?.invoice_belong_area !== 1,
        changeInterceptor: (value, oldValue) => {
          return ModalConfirm({
            value, oldValue, formData,
            title: '确定更改是否海外INVOICE吗？',
            content: '更改后，发票信息会清空，需重新上传',
          })
        }
      }
    }
  },
  'invoice_info.invoice_list': {
    label: '发票信息',
    required: true,
    col: 24,
    validateTrigger: false,
    watchChildFormValidate: true,
    render: ({ formData, detailData }, { view, elementProps }) => {
      const content = {
        belongArea: formData?.invoice_info?.invoice_belong_area,
        isOverseaInvoice: formData?.invoice_info?.is_oversea_invoice,
        currency: detailData?.base_info?.currency // 绑定执行数据，内包
          || "RMB",
        demandId: detailData?.base_info?.demand_id,
      }
      return <InvoiceInformation view={view} content={content} ref={elementProps?.invoiceFormRef} />
    }
  },
});

export { PrePaymentFormModel };
